import { render } from "./page.vue?vue&type=template&id=0808bb1f"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"

import "./page.vue?vue&type=style&index=0&id=0808bb1f&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\gpt\\chatgpt-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__